import './PtaMeetings.scss';
import images from '../../assets/images';
import { GET_ALL_PTA_MEETING, GET_RECORDED_MEETING_FOR_TEACHER_AND_PTA, GET_RECORDED_MEETING_ADMIN_BY_CATEGORY, DELETE_PTA_MEETING } from '../AdminPta/api/PtaQuery';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useCallback, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../../redux/app/hooks';
import Loader from '../../components/Loader/Loader';
import ToasterWithMessage from '../../components/toaster';
import { useDispatch } from 'react-redux';
import { formatSavedDate, getScreenDimensions } from '../../utils/helper';
import CreateSchedulePta from '../../components/CreateSchedulePta/CreateSchedulePta';
import PtaHeader from '../../components/PtaHeader/PtaHeader';
import PreviousMeetings from '../../components/PreviousMeetings/PreviousMeetings';
import VideoViewer from '../../components/VideoViewer/VideoViewer';
import PtaScheduledMeeting from '../../components/PtaScheduledMeeting/PtaScheduledMeeting';
import { FETCH_POLICY, JITSI, PTA_ROLE, SCHOOL_ADMIN, TEACHER_ROLE } from '../../utils/constants';
import StudentVerifyClassCode from '../AdminLoginPage/components/StudentVerifyClassCode';
import MaterialActionsOverlay, { MenuItemType } from '../../components/ActionsOverlay/MaterialActionsOverlay';
import { setChangeMenu, setCurrentSessionDetail } from '../../redux/slices/dashboardSlice';
import ConfirmationPopup from '../../components/ConfirmationPopup/ConfirmationPopup';
import PtaMeetingPopup from '../../components/PtaMeetingPopup/PtaMeetingPopup';
import { debounce } from '@mui/material';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { MeetingCategoryType, RecorderPtaMeetingType } from '../AdminPta/AdminPta';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';
import MobileHeader from '../../components/MobileHeader/MobileHeader';

export interface PtaMeetType {
  mId: string,
  mStartTime: string,
  mEndTime: string,
  mSessionUrl: string | null,
  mcId: string,
  mTopic: string,
  isActive: boolean,
  mCode: string,
  mParticipantCount: number,
  mStatus: string
  hostId?: string;
  isRecordStart: boolean,
  recordStartTime:string| null,
  serverUrl?: string | null;
  botUrl?: string | null;
  meetingType?: string | null;
  participantIds: string[]
}

const PtaMeetings = () => {

  const {error, success} = ToasterWithMessage();
  const {localStream, setIsMeetingEndByHost} = useGlobalState();
  const { backArrow, MenuShareIcon, DeleteClass, PencilIcon, DeleteGif, backArrowWhite, searchCloseIcon, searchIcon } = images;
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [isClickedSessionDetail,setIsClickedSessionDetail] = useState<boolean>(false);
  const [showCreateScheduling,setShowCreateScheduling] = useState<boolean>(false);
  const [singleSessionDetail,setSingleSessionDetail] = useState<PtaMeetType>(); 
  const [savedSessionsList, setSavedSessionsList] = useState<RecorderPtaMeetingType[]>();
  const [clickedVideoUrl,setClickedVideoUrl] = useState<string>();
  const [clickedMeetingDetails,setClickedMeetingDetails] = useState<PtaMeetType>();
  const [clickedCategoryDetails,setClickedCategoryDetails] = useState<MeetingCategoryType>();
  const [liveSessionsList,setLiveSessionsList] = useState<PtaMeetType[]>([]);
  const dispatch = useDispatch();
  const location = useLocation();  
  const [searchValue, setSearchValue] = useState<string>("");
  const [clickedVideoData, setClickedVideoData] = useState<RecorderPtaMeetingType>();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isShowBackArrow, setIsShowBackArrow] = useState<boolean>(true);
  const categoryListLoadingSidebar = useAppSelector((state) => state.dashboard.categoryListLoading);
  const [showVerify, setShowVerify] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openOverlay, setOpenOverlay] = useState<boolean>(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [openPtaPopup, setOpenPtaPopup] = useState<boolean>(false);
  const [ptaPopupType, setPtaPopupType] = useState<'generateCode' | 'copyCode' | 'editCategory' | 'shareCode'>();
  const [refetch, setRefetch] = useState<boolean>(false);
  const navigate = useNavigate();
  let selectedCategory: MeetingCategoryType = location?.state?.category; 
  const meetService = useAppSelector((state) => state.auth.meetService);
  const { isMobileScreen } = getScreenDimensions();
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);
  const { adminProfileImage, adminProfile, role } = useAppSelector((state) => state?.auth);
  const StudentName = adminProfile?.getCurrentUser?.nodes?.[0]?.uFullName;

  const menuItem: MenuItemType[] = [
    {
      icon: PencilIcon,
      label: "Edit",
      onClick: () => {
      setShowCreateScheduling(true);
      setEditClicked(true);
      handleCloseActions();
      }
    },
    {
      icon: DeleteClass,
      label: "Delete Schedule",
      onClick: () => {
      setOpenConfirmationPopup(true);
      handleCloseActions();
      }
    },
    {
      icon: MenuShareIcon,
      label: "Share meeting code",
      onClick: () => {
      setPtaPopupType('shareCode');
      setOpenPtaPopup(true);
      handleCloseActions();
      }
    }
  ]

  const [ getAllPtaMeetings, {loading} ] = useLazyQuery(GET_ALL_PTA_MEETING, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setLiveSessionsList(data?.getAllMeetings);
      setClickedCategoryDetails(undefined);
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [ getRecordedMeetingsForTeacherAndPta, { loading: loadingPtaRecorded } ] = useLazyQuery(GET_RECORDED_MEETING_FOR_TEACHER_AND_PTA, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setSavedSessionsList(data?.allRecordedSessions?.nodes);
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [ getRecordedMeetingAdminByCategory, { loading: loadingPtaRecordedAdminByid } ] = useLazyQuery(GET_RECORDED_MEETING_ADMIN_BY_CATEGORY, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setSavedSessionsList(data?.allRecordedSessions?.nodes );
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [ deletePtaMeeting, { loading: loadingDeletePtaMeeting } ] = useMutation(DELETE_PTA_MEETING, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      success('Meeting deleted succesfully');
      fetchUpcomingSessions();
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  useEffect(() => {
    dispatch(setCurrentSessionDetail({startDate: null, endDate: null}));
    setIsMeetingEndByHost(false);
      //To set stop camera and microphone when initial render.
      if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
  }, [])

  const fetchUpcomingSessions = () => {    
    if (selectedCategory) {
      getAllPtaMeetings({
        variables: {
          input: {
            ...((role === PTA_ROLE) ? {mcCode: selectedCategory?.mcCode } : {mcId: selectedCategory?.mcId}),
            startDate: dayjs()
          }
        }
      });
      fetchRecordedSessions();
    }
  }

  useEffect(() => {
    handleCloseVideo();
    selectedCategory = location?.state?.category;
    if (location?.state?.meeting !== undefined && role === PTA_ROLE) {
      fetchUpcomingSessions();
      fetchRecordedSessions();
      setSingleSessionDetail(location?.state?.meeting);
      setIsClickedSessionDetail(true);
      setIsShowBackArrow(true);
    }
    else if (role === SCHOOL_ADMIN || selectedCategory?.mcCode === localStorage.getItem('generalCode')) {
      fetchUpcomingSessions();
      fetchRecordedSessions();
      setSingleSessionDetail(undefined);
      setIsClickedSessionDetail(false);
      setShowVerify(false);
    }
    else {
      if (localStorage.getItem('isVerify') === 'false') {
        setShowVerify(true);
        setSingleSessionDetail(undefined);
        setIsClickedSessionDetail(false);
        return;
      }
      else {
        setShowVerify(false);
        fetchUpcomingSessions();
        setIsShowBackArrow(role === PTA_ROLE ? false : true);
        setSingleSessionDetail(undefined);
      }
    }
  }, [location?.state, refetch, localStorage.getItem('isVerify'), localStorage.getItem('generalCode')])


  const fetchRecordedSessions = () => {
    if ((role === PTA_ROLE || role === TEACHER_ROLE) && selectedCategory) {
      getRecordedMeetingsForTeacherAndPta({
        variables: {
          mcCode: selectedCategory?.mcCode,
          limit: null,
          offset: null,
          mcId: selectedCategory?.mcId,
          searchInput: `%${searchValue}%`
        }
      });
    }
    else if (role === SCHOOL_ADMIN && selectedCategory) {
      getRecordedMeetingAdminByCategory({
        variables: {
          mcId: selectedCategory?.mcId,
          limit: null,
          offset: null,
          searchInput: `%${searchValue}%`
        }
      });
    }
  }

  const handleBack = () => {
    if (isShowBackArrow && role === PTA_ROLE) {
      setIsShowBackArrow(false);
      setIsClickedSessionDetail(false);
      setSingleSessionDetail(undefined);
      navigate('/pta-meetings', {
        state: {
          category: selectedCategory
        }
      });
    }
    if (isShowBackArrow && role === TEACHER_ROLE && !isClickedSessionDetail) {
      dispatch(setChangeMenu({changeMenu: true}))
    }
    if (!isClickedSessionDetail && role === SCHOOL_ADMIN) {
      navigate("/admin-pta");
    }
    setRefetch(!refetch);
    setIsClickedSessionDetail(false);
    setSingleSessionDetail(undefined);
    setClickedMeetingDetails(undefined);
  }  

  //To close video detailed view
  const handleCloseVideo = () => {
    setClickedVideoData(undefined);
    setClickedVideoUrl(undefined);
  }

  const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, MeetingDetails: PtaMeetType) => {
    event.stopPropagation();
    if (MeetingDetails) {
        setAnchorEl(event.currentTarget);
        setOpenOverlay(true);
        setClickedMeetingDetails(MeetingDetails);
    }
  };

  const handleCloseActions = () => {
      setAnchorEl(null);
      setOpenOverlay(false);
  };

  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    if (clickedMeetingDetails) {
      deletePtaMeeting({
        variables: {
          mId: clickedMeetingDetails?.mId,
          ...(meetService === JITSI ? { meetingType: "JITSI" } : {}),
        }
      })
      setShowCreateScheduling(false);
      setEditClicked(false);
    }
  }

  const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
  }

  const closePtaPopup = () => {
    setOpenPtaPopup(false);
  }

  const getHeader = (text: string | undefined) => {
    const header = `All ${text} Meetings`;
    if (text && (text.toLowerCase().includes("meetings") || text.toLowerCase().includes("meeting"))) {
      return `All ${text}`;
    }
    return header;
  };

  const handleSearchDebounceAdminByCategory = useCallback(
    debounce((value, searchCategory) => {
      setSearchValue(value);
      getRecordedMeetingAdminByCategory({
        variables: {
          limit: null,
          offset: null,
          searchInput: `%${value}%`,
          mcId: searchCategory?.mcId
        }
      });
    }, 500),
    [getRecordedMeetingAdminByCategory]
  );

  const handleSearchDebounceTeacherAndPta = useCallback(
    debounce((value, searchCategory) => {
      setSearchValue(value);
      getRecordedMeetingsForTeacherAndPta({
        variables: {
          mcId: searchCategory?.mcId,
          mcCode: searchCategory?.mcCode,
          limit: null,
          offset: null,
          searchInput: `%${value}%`
        }
      })
    }, 500),
    [getRecordedMeetingsForTeacherAndPta]
  );

  
  const handleSearchClick = () => {
    setisSearchClick(true);
  }

  const handleCloseSearch = () => {
      setisSearchClick(false);
      setSearchValue("");
      handleSearchDebounceTeacherAndPta("", selectedCategory);
  }

  const searchOnChange = (event: { target: { value: any; }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounceTeacherAndPta) {
      handleSearchDebounceTeacherAndPta(event?.target?.value, selectedCategory);
    }
  }

  const showLoader = loading || ((loadingPtaRecorded || loadingPtaRecordedAdminByid) && singleSessionDetail === undefined) || loadingDeletePtaMeeting || categoryListLoadingSidebar || ((liveSessionsList === undefined || savedSessionsList === undefined) && !showVerify) || selectedCategory === null

  return (
    <>
      {(!clickedVideoUrl) ? (
        <div className={`PtaMainContainer ${ showVerify && 'ptaVerifyContainer' }`}>
          {isSearchClick && !showCreateScheduling && <div className={`ptaSearch ${(isMobileScreen && isSearchClick) ? 'mobileSearch' : ''}`}>
              <div className='SearchIconContainer'><img src={searchIcon} alt='searchIcon' className='commonSearchIconStyle' /></div>
              <input id="searchBox" type='text' placeholder='Search' onChange={searchOnChange} value={searchValue} className='SearchInputFieldStyle' />
              {(isMobileScreen && isSearchClick) && <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />}
          </div>}
          {isMobileScreen && !isSearchClick && !showCreateScheduling && role !== TEACHER_ROLE && !isClickedSessionDetail && (
            <MobileScreenHeader
                handleSearchClick={handleSearchClick}
                profileImage={adminProfileImage}
                role={role}
                studentName={StudentName}
                profile={adminProfile}
            />
          )}
          {((!showVerify || (role === TEACHER_ROLE && showVerify && isMobileScreen)) && !categoryListLoadingSidebar && !isSearchClick) && (
            <div className='headerContainer'>
              <PtaHeader
                title={(showCreateScheduling && isMobileScreen) ? "Schedule your PTA Meetings" : (role === SCHOOL_ADMIN ? getHeader(selectedCategory?.mcOriginalType) : "All Meeting")}
                subtitle={!showCreateScheduling ? "Scheduled Meetings" : ""}
                addLabel=''
                subImage={(role === TEACHER_ROLE && singleSessionDetail === undefined) ? backArrowWhite : backArrow}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                handleSearchDebounce={role === SCHOOL_ADMIN ? handleSearchDebounceAdminByCategory : handleSearchDebounceTeacherAndPta}
                handleBack={handleBack}
                isShowBackArrow={(role === PTA_ROLE && !isClickedSessionDetail) ? false : isShowBackArrow}
                setEditClicked={setEditClicked}
                selectedCategory={selectedCategory}
                showCreateScheduling={showCreateScheduling}
              />
             {isMobileScreen && (showVerify || role === TEACHER_ROLE || isClickedSessionDetail) && !isSearchClick && !showCreateScheduling && 
              <MobileHeader {...((role === TEACHER_ROLE || isClickedSessionDetail) && {handleSearchClick})}/>}
            </div>
          )}

          {showLoader && <Loader bottom='100px'/>}

          {(showCreateScheduling && !showVerify && role === SCHOOL_ADMIN && !showLoader && !isSearchClick) && (
            <div className='createScheduleMainContainer'>
              <CreateSchedulePta 
                editClicked={editClicked}
                setEditClicked={setEditClicked} 
                setShowCreateScheduling={setShowCreateScheduling}
                clickedSessionDetails={clickedMeetingDetails} 
                fetchUpcomingSessions={fetchUpcomingSessions}
                setOpenConfirmationPopup={setOpenConfirmationPopup}
              />
            </div>
          )}

          {(!showVerify && !showLoader && !showCreateScheduling && !isSearchClick) && (
            <div className={`meetListContainer ${singleSessionDetail || liveSessionsList?.length === 0 ? 'meetListContainerSingleView' : ''}`}>
              <PtaScheduledMeeting
                setSingleSessionDetail={setSingleSessionDetail} 
                singleSessionDetail={singleSessionDetail} 
                upcomingSessionList = {liveSessionsList}
                setIsClickedSessionDetail={setIsClickedSessionDetail}
                setIsShowBackArrow={setIsShowBackArrow}
                handleClickMoreIcon={handleClickMoreIcon}
                fetchRecordedSessions={fetchRecordedSessions}
                setRefetch={setRefetch}
                refetch={refetch}
              />
            </div>
          )}

          {(!showLoader && !showVerify && !showCreateScheduling) && (
            <div className={`previousMeetingContainer ${(!savedSessionsList || savedSessionsList?.length === 0) && isMobileScreen ? "noDataContainer" : ""}`}>
              <PreviousMeetings 
                setClickedVideoUrl = {setClickedVideoUrl} 
                savedSessionsList = {savedSessionsList} 
                setClickedVideoData = {setClickedVideoData}
                isSearchClick={isSearchClick}
              />
            </div>
          )}

          {(showVerify && !showLoader && !showCreateScheduling) && (
            <div className='ptaVerfiyInnerContainer'>
              <div className='ptaVerifyTitleContainer'>
                <div className='ptaVerifyTitle'>{`${selectedCategory ? selectedCategory?.mcOriginalType : "PTA" }`}</div>
                <div className='ptaVerifySubTitle'>Please provide the passcode for this meeting</div>
              </div>
              <StudentVerifyClassCode loginType='ptaVerify' selectedCategory={selectedCategory} />
            </div>
          )}

        </div>
      ) : (
        <div className='viewVideoContainer'>
          <div className='viewVideoHeader'>
            <div className='headerLeft'>
              <img src={backArrow} onClick={handleCloseVideo} alt='backArrow' className='backIcon' />
              <div>{ clickedVideoData?.topic }</div>
            </div>
            <div className='headerRight'><span>{ formatSavedDate(clickedVideoData?.createdAt) }</span></div>
          </div>
          <div className='videoViewer'>
            <VideoViewer 
              video={clickedVideoUrl ? clickedVideoUrl : ''} 
              onClose={handleCloseVideo} 
              type={"Pta Meeting"} 
              videoRef = {videoRef}
              videoId = {clickedVideoData?.rsId ? clickedVideoData?.rsId : ''}
              videoData = {clickedVideoData}
            />
          </div>
        </div>
      )}

      <MaterialActionsOverlay
        anchorEl={anchorEl}
        open={openOverlay}
        handleClose={handleCloseActions}
        menuItems={menuItem}
        actionsHeight={selectedCategory ? '110px' : '90px'}
        position={'left'}
        verticalPosition="bottom"
      />

      <ConfirmationPopup
        open={openConfirmationPopup}
        message={`Are you sure you want to Delete this session?`}
        gifData={DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'195px'}
      />

      {(ptaPopupType) && (
        <PtaMeetingPopup 
          openPopup={openPtaPopup}
          closePopup={closePtaPopup}
          message={'Copy and share this meeting code with Parents and Teachers Association'}
          type={ptaPopupType}
          value={selectedCategory?.mcCode}
          setRefetch={setRefetch}
          clickedCategoryDetails={clickedCategoryDetails}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default PtaMeetings;
